module.exports = __webpack_public_path__ + "img/Rectangle 43.ba6714bf.svg";